import React from "react"
import { withStyles } from '@material-ui/core/styles'
import NavBar from "../NavBar"
import Grid from '@material-ui/core/Grid'
import ReactSwipeEvents from 'react-swipe-events'
import { connect } from "react-redux"
import moment from 'moment'
import { I18n } from 'react-redux-i18n'
import TodayIcon from '@material-ui/icons/Today'
import IconButton from '@material-ui/core/IconButton'

import AppointmentList from './appointment/AppointmentList'

import {setDate, setFirstDate} from '../../actions/weekActions'

import {
  setFromDate,
  setToDate
} from '../../actions/newAppointmentActions'

const styles = theme => ({
  primaryColor: {
    color: '#009fe3',
  },
  weekList: {
    position: 'relative',
    height: '100px',
    overflow: 'hidden',
    borderBottom: '1px solid black'
  },
  weekGrid: {
    width: 100/7*21 + '%',
    position: 'absolute',
  },
  weekGridItem: {
    height: '100px',
    width: 'calc(' + 100/21 + '% - 2px)',
    borderLeft: '1px solid black',
    borderRight: '1px solid black',
    display: 'inline-block',
    verticalAlign: 'top',
    backgroundColor: theme.palette.grey["700"],
    color: theme.palette.grey["500"],
    textAlign: 'center',
    cursor: 'pointer',
  },
  weekGridActive: {
    backgroundColor: theme.palette.primary.main,
    color:'#FFFFFF'
  },
  weekGridOdd: {
    backgroundColor: theme.palette.grey["800"],
  },
  weekGridSelection: {
    width: 'calc(' + 100/7 + '%)',
    left: 'calc(50% - ((' + 100/7 + '%)/2))',
    height: '100px',
    position: 'absolute',
    /*backgroundColor: theme.palette.primary.main,
    opacity: 0.5,*/
    borderLeft: '1px solid black',
    borderRight: '1px solid black',
    zIndex: 50
  },
  weekDay: {
    fontSize:20,
    paddingTop: 15
  },
  weekDigit: {
    fontSize:40,
    fontWeight:'bold'
  },
  button: {
    position: 'fixed',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2,
  },
  today: {
    padding: '0.5rem 1.5rem',
    backgroundColor: theme.palette.grey["800"],
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold'
  },
  todayDate: {
    marginLeft: '1rem',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '22px'
  },
  todayButton: {
    color: theme.palette.primary.contrastText,
    float: 'right',
    height: '22px',
    width: '22px'
  }
});


class Week extends React.Component {
  state = {
    position: 0,
    list: []
  }

  componentWillMount(){
    this.props.dispatch(setFirstDate(moment(this.props.match.params.week, 'YYYYMMDD')))
    this.updateList(moment(this.props.match.params.week, 'YYYYMMDD'))
  }

  componentWillUpdate(nextProps){
    if(this.props.week.date != null && this.props.week.date.diff(nextProps.week.date, 'days') !== 0){
      this.updateList(nextProps.week.date)
    }
  }

  setDate(date){
    this.props.dispatch(setDate(date))
    this.props.dispatch(setFromDate(date))
    this.props.dispatch(setToDate(date))
  }

  onClickSetToday = () => {
    const date = moment()
    this.props.dispatch(setDate(date))
    this.updateList(date)
  }

  onSwiped = (e, originalX, originalY, endX, endY, deltaX, deltaY) =>{
    if(deltaX > -10 && deltaX < 10) return
    let swiped = Math.round(deltaX / (document.getElementById('grid-slider').offsetWidth/21))
    swiped = swiped - (swiped * 2)

    const newDay = this.props.week.date.clone().add(swiped, 'days')

    this.setState({
      position: 0
    })

    this.setDate(newDay)
  }

  onClickGridItem = (i) => {
    const newDay = this.props.week.date.clone().add(i, 'days')

    this.setState({
      position: 0
    })

    this.setDate(newDay)
  }

  updateList = (selectedDate) => {
    let list = []
    const range = 10

    for(let i = -range; i<=range; i++){
      const day = selectedDate.clone().add(i, 'days')
      let classes = `${this.props.classes.weekGridItem}`

      if(i === 0){
        classes = `${this.props.classes.weekGridItem} ${this.props.classes.weekGridActive}`
      }else if((i+range) % 2 === 1){
        classes = `${this.props.classes.weekGridItem} ${this.props.classes.weekGridOdd}`
      }

      list.push(
        <div className={classes} key={i} onClick={() => this.onClickGridItem(i)}>
            <div className={this.props.classes.weekDay}>{day.locale(this.props.i18n.locale).format('dddd').substring(0,3).toUpperCase()}</div>
            <div className={this.props.classes.weekDigit}>{day.date()}</div>
        </div>
      )
    }

    this.setState({
      list: list
    })
  }

  onSwiping = (e, originalX, originalY, endX, endY, deltaX, deltaY) => {
    this.setState({
      position: deltaX
    })
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <NavBar/>
        <ReactSwipeEvents onSwiping={this.onSwiping} onSwiped={this.onSwiped}>
          <Grid container justify="center">
            <Grid item xs={12} md={6} className={classes.weekList}>
              <div className={classes.weekGrid} id="grid-slider" style={{left: 'calc(-100% + ' + this.state.position + 'px)'}}>
                {this.state.list}
              </div>
              <div className={classes.weekGridSelection}></div>
            </Grid>
          </Grid>
        </ReactSwipeEvents>
        {
          this.props.week.date != null
          ?
          <Grid container justify="center">
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid item xs={9} className={classes.today}>
                  {this.props.week.date.isSame(new Date(), "day") ?
                    (
                      <span>
                        {I18n.t('month.today')}
                        <span className={classes.todayDate}>
                          {this.props.week.date.format('DD-MM-YYYY')}
                        </span>
                      </span>
                    ) : (
                      <span>
                        {this.props.week.date.format('dddd')}
                        <span className={classes.todayDate}>
                          {this.props.week.date.format('DD-MM-YYYY')}
                        </span>
                      </span>
                    )
                  }
                </Grid>
                <Grid item xs={3} className={classes.today}>
                  <IconButton className={classes.todayButton} onClick={this.onClickSetToday} aria-label="Today">
                    <TodayIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          :
          null
        }
        <Grid container justify="center">
          <Grid item xs={12} md={6}>
            {
              this.props.week.date != null
              ?
              <AppointmentList userId={this.props.user.user.id} date={this.props.week.date} />
              :
              null
            }
          </Grid>
        </Grid>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch
})

const mapStateToProps = (state) => ({
  week: state.week,
  user: state.user,
  i18n: state.i18n
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Week))



// WEBPACK FOOTER //
// ./src/js/components/pages/Week.js